module.exports = __webpack_public_path__ + "antigua-and-barbuda.svg?c6c13234ac2ab6be83d859ceaced05a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/antigua-and-barbuda.svg
// module id = 93
// module chunks = 10